import type React from 'react';
import { Helmet } from 'react-helmet-async';

type HeadDataProps = {
  title: string;
};

export const HeadData: React.FC<HeadDataProps> = ({ title }) => {
  const fullTitle = `${title} | eMBA by GLOBIS`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};
